export default "__VITE_ASSET__VNh$AwBU__"